// src/components/UI/AskedPopup.js
import React from 'react';
import Popup from './Popup';

/**
 * AskedPopup is used on the Question Asked page (questions the admin has asked).
 *
 * For Pending Questions:
 *   - Only the Delete option is available (with confirmation).
 *
 * For Answered Questions:
 *   - Only the View Answer option is available.
 */
const AskedPopup = ({
  q,             // the question object
  onDelete,      // delete action (for pending questions only)
  onView,        // view answer action (for answered questions)
  onClose,       // callback to close the popup
  confirm,       // if true, show confirmation UI for delete
  onOpenConfirm, // callback to open confirmation mode
  showLabel      // optional label for the primary action (default "View answer")
}) => {
  // If the question is pending, we show only the delete option;
  // if answered, we show only the primary action ("View answer").
  if (q.status === "Pending") {
    return (
      <Popup
        onDelete={onDelete}
        onClose={onClose}
        confirm={confirm}
        onOpenConfirm={onOpenConfirm}
      />
    );
  } else {
    return (
      <Popup
        onPrimaryAction={onView}
        primaryLabel={showLabel || "View answer"}
        onClose={onClose}
      />
    );
  }
};

export default AskedPopup;
